"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.prepareScope = exports.prepareConfig = exports.getEnvironment = exports.isBrowserSupported = void 0;

var _jsonStringifySafe = _interopRequireDefault(require("json-stringify-safe"));

var _media = require("bloko/common/media");

var _generatedBrowserVersionsForSentryLogging = _interopRequireDefault(require("../tools/generatedBrowserVersionsForSentryLogging"));

var _removeData = require("../removeData");

var _pushAxiosDataToSentry = _interopRequireDefault(require("../pushAxiosDataToSentry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); _groups.set(_this, groups || _groups.get(re)); return _setPrototypeOf(_this, BabelRegExp.prototype); } _inherits(BabelRegExp, RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; if (_typeof(args[args.length - 1]) !== "object") { args = [].slice.call(args); args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var isBrowserSupported = function isBrowserSupported() {
  if (!window.bloko || !window.bloko.getUserAgentDetails) {
    return false;
  }

  var userAgentDetails = window.bloko.getUserAgentDetails(window.navigator.userAgent, _generatedBrowserVersionsForSentryLogging.default);
  return !!(userAgentDetails.isSupported && userAgentDetails.browser);
};

exports.isBrowserSupported = isBrowserSupported;

var getEnvironment = function getEnvironment() {
  var re = window.navigator.userAgent.match(/test_host=(\w+)/);
  var isAutotests = !!re;
  var standName = re && re[1] ? re[1] : null;
  return {
    isAutotests: isAutotests,
    standName: standName
  };
};

exports.getEnvironment = getEnvironment;

var parseSentryConfig = function parseSentryConfig(config) {
  try {
    return JSON.parse(config);
  } catch (e) {
    console.error('Sentry config could not be parsed', e);
    return null;
  }
};

var getIgnoreConfig = function getIgnoreConfig(type, globalConfig) {
  if (!globalConfig) {
    return [];
  }

  var globalIgnoreConfig = globalConfig[type];

  if (!globalIgnoreConfig) {
    return [];
  }

  var _globalIgnoreConfig$s = globalIgnoreConfig.strings,
      strings = _globalIgnoreConfig$s === void 0 ? [] : _globalIgnoreConfig$s,
      _globalIgnoreConfig$r = globalIgnoreConfig.regexps,
      regexps = _globalIgnoreConfig$r === void 0 ? [] : _globalIgnoreConfig$r;

  if (!strings.length && !regexps.length) {
    return [];
  }

  var regexpObjects = regexps.map(function (regexp) {
    try {
      if (typeof regexp === 'string') {
        return new RegExp(regexp, 'i');
      }

      return new RegExp(regexp.pattern, regexp.flags);
    } catch (e) {
      console.error(e);
      return null;
    }
  }).filter(function (regexp) {
    return regexp;
  });
  return [].concat(_toConsumableArray(strings), _toConsumableArray(regexpObjects));
};

var setFramesInAppFlag = function setFramesInAppFlag(staticHost) {
  var frames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var appHosts = [staticHost, "".concat(window.location.protocol, "//").concat(window.location.host)]; // eslint-disable-next-line camelcase

  frames.forEach(function (frame) {
    return frame.in_app = appHosts.some(function (host) {
      return frame.filename.startsWith(host);
    });
  });
};

var isErrorInCache = function isErrorInCache(errorMessage) {
  var ERRORS_CACHE_KEY = '__jsErrorsCache';
  var ERRORS_CACHE_STORING_DURATION_MS = 24 * 60 * 60 * 1000; // 24 часа

  var errors;

  try {
    errors = JSON.parse(window.localStorage.getItem(ERRORS_CACHE_KEY));
  } catch (ignore) {
    errors = [];
  }

  if (!('isArray' in Array && Array.isArray(errors))) {
    errors = [];
  }

  var currentDate = Date.now();
  var relevantErrors = errors.filter(function (cacheError) {
    return cacheError.date + ERRORS_CACHE_STORING_DURATION_MS >= currentDate;
  });
  var inCache = relevantErrors.some(function (errorCache) {
    return errorCache.message === errorMessage;
  });

  if (!inCache) {
    relevantErrors.push({
      date: currentDate,
      message: errorMessage
    });

    try {
      window.localStorage.setItem(ERRORS_CACHE_KEY, JSON.stringify(relevantErrors));
    } catch (ignore) {} // eslint-disable-line no-empty

  }

  return inCache;
};

var getLastCall = function getLastCall(event) {
  var _event$exception, _event$exception$valu, _event$exception$valu2;

  var frames = ((_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : (_event$exception$valu = _event$exception.values[0]) === null || _event$exception$valu === void 0 ? void 0 : (_event$exception$valu2 = _event$exception$valu.stacktrace) === null || _event$exception$valu2 === void 0 ? void 0 : _event$exception$valu2.frames) || [];

  if (!frames.length) {
    return false;
  }

  return frames[frames.length - 1].function ? String(frames[frames.length - 1].function) : false;
};

var prepareConfig = function prepareConfig(_ref) {
  var _parsedConfig$ignoreE;

  var sentryJsConfig = _ref.sentryJsConfig,
      sentryDSN = _ref.sentryDSN,
      buildVersion = _ref.buildVersion,
      staticHost = _ref.staticHost,
      beforeSendCallback = _ref.beforeSendCallback,
      getUser = _ref.getUser,
      getExtraData = _ref.getExtraData,
      excludeStoreKeys = _ref.excludeStoreKeys;
  var parsedConfig = parseSentryConfig(sentryJsConfig);
  var ignoreErrors = getIgnoreConfig('ignoreErrors', parsedConfig);
  var ignoreErrorsStacktrace = ((_parsedConfig$ignoreE = parsedConfig === null || parsedConfig === void 0 ? void 0 : parsedConfig.ignoreErrors) !== null && _parsedConfig$ignoreE !== void 0 ? _parsedConfig$ignoreE : {}).stacktraces;
  var denyUrls = getIgnoreConfig('ignorePaths', parsedConfig);
  return {
    dsn: sentryDSN,
    release: buildVersion,
    ignoreErrors: ignoreErrors,
    denyUrls: denyUrls,
    includePaths: [staticHost, window.location.host, 'webpack-internal'],
    maxBreadcrumbs: 15,
    normalizeDepth: 8,
    beforeSend: function beforeSend(event) {
      var _event$exception2, _event$exception2$val, _event$exception2$val2;

      if (document.body === null) {
        return null;
      }

      var MAX_LAST_ACTION_PAYLOAD_LENGTH = _removeData.MAX_EXTRA_DATA_LENGTH / 20;

      if (!event.fingerprint && (_event$exception2 = event.exception) !== null && _event$exception2 !== void 0 && (_event$exception2$val = _event$exception2.values) !== null && _event$exception2$val !== void 0 && (_event$exception2$val2 = _event$exception2$val[0]) !== null && _event$exception2$val2 !== void 0 && _event$exception2$val2.value) {
        event.fingerprint = [event.exception.values[0].value];
      }

      var url = event.request.url;
      var lineNumber = 0;
      var errorMessage = event.message;

      if (event.exception) {
        var error = event.exception.values[0];
        errorMessage = error.value;

        if (error.stacktrace) {
          if (Array.isArray(ignoreErrorsStacktrace)) {
            if (ignoreErrorsStacktrace.some(function (stacktraceString) {
              var _stacktraceString$mat = stacktraceString.match( /*#__PURE__*/_wrapRegExp(/^((?:(?!\()[\s\S])+)?(?:\(<((?:(?!>)[\s\S])+)>\))?$/, {
                func: 1,
                module: 2
              })),
                  _stacktraceString$mat2 = _stacktraceString$mat.groups,
                  func = _stacktraceString$mat2.func,
                  module = _stacktraceString$mat2.module;

              return (func || module) && error.stacktrace.frames.some(function (frame) {
                return (func ? frame.function.includes(func) : true) && (module ? frame.filename.includes(module) : true);
              });
            })) {
              return null;
            }
          }

          var stacktrace = error.stacktrace.frames[error.stacktrace.frames.length - 1];
          url = stacktrace.filename;
          lineNumber = stacktrace.lineno; // Проставляем флаг - произошла ли ошибка на наших хостах

          setFramesInAppFlag(staticHost, error.stacktrace.frames);
        }
      }

      event = (0, _pushAxiosDataToSentry.default)(event);
      var callbackResult = !beforeSendCallback || beforeSendCallback(event);

      if (!callbackResult) {
        return null;
      } // Отсылаем ошибку одного типа только один раз в сутки.


      if (isErrorInCache("".concat(errorMessage, "|").concat(url, "|").concat(lineNumber))) {
        return null;
      }

      if (event.user) {
        event.user = getUser();
      }

      if (event.extra) {
        var _window$navigator, _event$extra$lastActi;

        event.extra = _objectSpread(_objectSpread({}, event.extra), getExtraData());
        event.extra.screenBreakpoint = (0, _media.getBreakpoint)();
        event.extra.documentStates = {
          readyState: document.readyState,
          visibilityState: document.visibilityState,
          onLineState: (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.onLine
        };

        if (document.body === null) {
          var _window$navigator2, _window$navigator3, _window$navigator4, _window$globalVars;

          event.extra.navigator = {
            platform: (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.platform,
            userAgentData: (_window$navigator3 = window.navigator) === null || _window$navigator3 === void 0 ? void 0 : _window$navigator3.userAgentData,
            webdriver: (_window$navigator4 = window.navigator) === null || _window$navigator4 === void 0 ? void 0 : _window$navigator4.webdriver
          };
          event.extra.performance = window.performance;
          event.extra.bodyIsExisted = (_window$globalVars = window.globalVars) === null || _window$globalVars === void 0 ? void 0 : _window$globalVars.bodyIsExisted;
        }

        (0, _removeData.removeExcludedFields)(event, excludeStoreKeys); // Убираем payload последнего action, если он тяжелый

        if ((_event$extra$lastActi = event.extra.lastAction) !== null && _event$extra$lastActi !== void 0 && _event$extra$lastActi.payload) {
          var lastActionPayloadLength = (0, _jsonStringifySafe.default)(event.extra.lastAction.payload).length;

          if (lastActionPayloadLength > MAX_LAST_ACTION_PAYLOAD_LENGTH) {
            event.extra.lastAction.payload = '[removed]';
          }
        }

        (0, _removeData.removeExtraData)(event);
      } // Добавляем последний вызов из стека, чтобы разделить одни и те же события на разных элементах


      event.fingerprint = [].concat(event.fingerprint, getLastCall(event)).filter(Boolean); // Если ошибка произошла в коде html странице, то проставляем тег fromStatic: false

      if (event.request.url === window.location.href) {
        event.tags.fromStatic = false;
      }

      return event;
    }
  };
};

exports.prepareConfig = prepareConfig;

var prepareScope = function prepareScope(environment, getExtraData, getUser) {
  return function (scope) {
    for (var _i = 0, _Object$entries = Object.entries(getExtraData()); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      scope.setExtra(key, value);
    }

    scope.setUser(getUser());
    scope.setTag('fromStatic', true);
    scope.setTag('fromDebug', false);
    scope.setTag('standName', environment.standName);
  };
};

exports.prepareScope = prepareScope;
var _default = {};
exports.default = _default;